import { Outlet } from 'react-router';
import { Button } from '../../../shared/components/button';
import { StateMessage } from '../../../shared/components/state-message';
import { TallyLoader } from '../../../shared/components/tally-loader';
import { useActiveLedger } from '../../ledgers/hooks/use-active-ledger';
import { BottomNav, MobileHeader } from './mobile-nav';
import { SidebarNav } from './sidebar-nav';

export function AppShell() {
  const { ledger, isLoading, error } = useActiveLedger();

  return (
    <div className="flex min-h-dvh w-full max-w-full overflow-x-clip">
      <SidebarNav />
      <div className="flex min-w-0 max-w-full flex-1 flex-col">
        <MobileHeader />
        <main className="mx-auto w-full min-w-0 max-w-6xl flex-1 px-4 pt-6 pb-28 md:px-8 lg:pt-10 lg:pb-12">
          {isLoading ? <TallyLoader label="Membuka Tally" /> : null}
          {error ? (
            <StateMessage
              tone="error"
              title="Daftar Tally gagal dimuat"
              description={error.message}
              action={<Button onClick={() => window.location.reload()}>Muat ulang</Button>}
            />
          ) : null}
          {!isLoading && !error && !ledger ? (
            <StateMessage
              title="Kamu belum punya Tally"
              description="Kirim /start ke bot untuk membuat Kas Pribadi, atau minta undangan dari teman."
            />
          ) : null}
          {ledger ? <Outlet context={ledger} /> : null}
        </main>
      </div>
      <BottomNav />
    </div>
  );
}
